import { Stack } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { PrevNextButtonGroup } from '@/components/form/baseInputs/Button/PrevNextButtonGroup';

export interface ManageIntegrationDataHeaderActionsProps {
  onPrevious: () => void;
  onNext: () => void;
  onCancel: () => void;
  onDone: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
  /** True while "Done" is committing. */
  isSaving: boolean;
}

/** Prev/Next navigate, Cancel closes without saving, and Done commits. */
export function ManageIntegrationDataHeaderActions({
  onPrevious,
  onNext,
  onCancel,
  onDone,
  isFirstStep,
  isLastStep,
  isSaving,
}: ManageIntegrationDataHeaderActionsProps) {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <PrevNextButtonGroup
        variant="secondary"
        size="sm"
        onPrevious={onPrevious}
        onNext={onNext}
        isPreviousDisabled={isFirstStep}
        isNextDisabled={isLastStep}
        disabled={isSaving}
      />

      <Button
        variant="secondary"
        size="sm"
        onClick={onCancel}
        disabled={isSaving}
      >
        Cancel
      </Button>

      <Button variant="primary" size="sm" onClick={onDone} loading={isSaving}>
        Done
      </Button>
    </Stack>
  );
}
